import type { ConnectionStatus } from "../core/connection";

type Props = {
  status: ConnectionStatus;
  errorReason?: string;
  onUseMock: () => void;
};

/**
 * Persistent status banners. Each status gets exactly one banner, or none for the steady states
 * (`connecting`, `connected`, `destroyed` render no banner — the header badge already covers
 * those).
 */
export function Banners({
  status,
  errorReason,
  onUseMock,
}: Props): React.JSX.Element | null {
  if (status === "connecting") {
    return (
      <div className="banner banner-timeout" role="status">
        Handshaking with the agent workspace. If this sits more than ~20s, the
        iframe never got onCreate. Check 3P app registration and iframe origin.
      </div>
    );
  }
  if (status === "mock") {
    return (
      <div className="banner banner-mock" role="status">
        MOCK MODE — synthetic data, not evidence of live behaviour
      </div>
    );
  }
  if (status === "timeout") {
    return (
      <div className="banner banner-timeout" role="status">
        <p>
          Not running inside the agent workspace. This is EXPECTED when the URL
          is opened directly — it must be embedded as a 3P app inside the Amazon
          Connect agent workspace to connect.
        </p>
        <button type="button" onClick={onUseMock}>
          Try mock mode instead
        </button>
      </div>
    );
  }
  if (status === "error") {
    return (
      <div className="banner banner-error" role="alert">
        App initialisation failed{errorReason ? `: ${errorReason}` : "."}
      </div>
    );
  }
  return null;
}
